import { illegalArity } from "@thi.ng/errors";
import { reduce } from "./reduce";
import { map } from "./xform/map";
export function transduce() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var acc, xs;

  switch (args.length) {
    case 4:
      xs = args[3];
      acc = args[2];
      break;

    case 3:
      xs = args[2];
      break;

    case 2:
      return map(function (x) {
        return transduce(args[0], args[1], x);
      });

    default:
      illegalArity(args.length);
  }

  return reduce(args[0](args[1]), acc, xs);
}